import getWithToken from './base/get-with-token'

const getCustomerGroup = id => getWithToken(`/customer/${id}/group`)()

export default getCustomerGroup
